<div class="tooltip" [innerHTML]="tooltipText()">{{ tooltipText() }}</div>
